import { Stack } from '@mui/material';

import { CalendarMeetingDto, MeetingAnalysisDto } from '@/api/generated';
import MeetingOverviewTasks from '@/components/Meeting/components/MeetingOverview/MeetingOverviewTasks';
import MeetingTopics from '@/components/Meeting/components/MeetingTopics';

import MeetingOverviewSections from './MeetingOverviewSections';
import { MeetingBrief } from './MeetingOverviewStyles';

interface SharedMeetingOverviewProps {
  meeting: CalendarMeetingDto | undefined;
  meetingAnalysis: MeetingAnalysisDto | undefined;
  onTimeClicked: (time: number | undefined) => void;
}

const SharedMeetingOverview = ({
  meeting,
  meetingAnalysis,
  onTimeClicked
}: SharedMeetingOverviewProps) => {
  // TODO: remove this once we have a proper brief from backend
  const brief = meeting?.overview?.brief || '';
  const cutBrief = brief.split('Timeframes and Titles:')[0];

  return (
    <Stack gap="24px">
      {meetingAnalysis?.sections ? (
        <MeetingOverviewSections
          meeting={meeting}
          sections={(meetingAnalysis?.sections || []).map(section => ({
            ...section,
            title: section.title?.split('_')[1] ?? '',
            content: section.content ?? ''
          }))}
          isDefaultTemplate={false}
          isLoadingMeetingAnalysis={false}
        />
      ) : (
        <>
          <MeetingBrief>{cutBrief}</MeetingBrief>
          <MeetingOverviewTasks meeting={meeting} />
          <MeetingTopics meeting={meeting} onTimeClicked={onTimeClicked} />
        </>
      )}
    </Stack>
  );
};

export default SharedMeetingOverview;
